module.exports = __webpack_public_path__ + "static/resume-cc1c5a6e6a30f7dd16434cd041fe65a0.pdf";